import * as React from 'react';

import Tabs from 'rc-tabs';

import { SearchCruises } from '@app/pages/MainPage/SearchCard/TabsSearchCard/SearchCruises';
import { SearchPackages } from '@app/pages/MainPage/SearchCard/TabsSearchCard/SearchPackages';
import { SearchHotel } from '@app/pages/MainPage/SearchCard/TabsSearchCard/SearchHotel';

import { Icon } from '@app/image/icon';

import 'rc-tabs/assets/index.css';
import '@app/scss/pages/main/searchCard.scss';

export enum ActiveTabKey {
	Cruises = 'cruises',
	Packages = 'packages',
	Hotels = 'hotels',
}

const tabs = (activeKey: ActiveTabKey) => ([
	{
		label: 'Cruises',
		key: ActiveTabKey.Cruises,
		children: <SearchCruises />,
	},
	{
		label: 'Cruise Packages & Tours',
		key: ActiveTabKey.Packages,
		children: <SearchPackages />,
	},
	{
		label: 'Hotels',
		key: ActiveTabKey.Hotels,
		children: <SearchHotel activeKey={activeKey} />,
	},
]);

export const extraContent = (
	<a
		href="https://travel.onlinevacationcenter.com/acton/media/12605/special-faqs"
		className="search-card__covid font-family_accent font-weight_medium text-size_small"
	>
		Travel Alerts
	</a>
);

export const SearchCard: React.FC = () => {
	const [activeKey, setActiveKey] = React.useState<ActiveTabKey>(ActiveTabKey.Cruises);

	return (
		<div className="search-card font-family_primary font-weight_medium text-size_normal">
			<Tabs
				items={tabs(activeKey)}
				moreIcon={<Icon.Ellipsis />}
				tabBarExtraContent={extraContent}
				onChange={(key: string) => setActiveKey(key as ActiveTabKey)}
			/>
		</div>
	);
};
